// I22 (Fabi, Spieltest Phase 4): Seltenheit von Items und Artefakten. Gewöhnliches kommt oft, Seltenes seltener,
// sehr Seltenes nur ab und zu. Die Gewichte stehen in run.json (rarityWeights).
import { runRules, type Rarity, type RunRules } from '../../content/index.ts';
import type { Rng } from '../rng.ts';

export function rarityWeight(def: { rarity?: Rarity }, rules: RunRules = runRules): number {
  return rules.rarityWeights[def.rarity ?? 'gewoehnlich'] ?? 1;
}

/** Eins aus der Liste, nach Seltenheit gewichtet */
export function pickByRarity<T extends { rarity?: Rarity }>(rng: Rng, list: T[], rules: RunRules = runRules): T {
  return sampleByRarity(rng, list, 1, rules)[0]!;
}

/** Bis zu n verschiedene aus der Liste, nach Seltenheit gewichtet */
export function sampleByRarity<T extends { rarity?: Rarity }>(rng: Rng, list: T[], n: number, rules: RunRules = runRules): T[] {
  const left = [...list];
  const out: T[] = [];
  while (out.length < n && left.length) {
    const total = left.reduce((a, d) => a + rarityWeight(d, rules), 0);
    let r = rng.next() * total;
    let i = left.findIndex((d) => (r -= rarityWeight(d, rules)) < 0);
    if (i < 0) i = left.length - 1;
    out.push(left.splice(i, 1)[0]!);
  }
  return out;
}
